/* eslint-disable @typescript-eslint/no-shadow */
// TODO: https://tasks.awstcprojects.com/browse/PLATFORM-4620 - remove above disable
import { ReactNode, useEffect, useMemo, useState } from "react";
import { AuthContext } from "@amzn/xb-hooks";
import { getCurrentVIASUser, refreshToken, login, logout } from "./endpoints";

const TOKEN_REFRESH_TIME_BUFFER_BEFORE_EXPIRY = 20 * 1000;

const getTimeToExpire = (tokenExpiration: number) =>
  tokenExpiration * 1000 - Date.now() - TOKEN_REFRESH_TIME_BUFFER_BEFORE_EXPIRY;

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);
  const [tokenExpiration, setTokenExpiration] = useState<number | null>(null);

  useEffect(() => {
    (async () => {
      try {
        // First check if the ID token is valid with current user endpoint and retrieve token expiration
        const { tokenExpiration } = await getCurrentVIASUser();
        setTokenExpiration(tokenExpiration);
        setIsAuthed(true);
      } catch (initialValidationError) {
        try {
          await refreshToken();
          const { tokenExpiration } = await getCurrentVIASUser();
          setTokenExpiration(tokenExpiration);
          setIsAuthed(true);
        } catch (refreshError) {
          setIsAuthed(false);
        }
      } finally {
        setIsLoading(false);
      }
    })();
  }, [refreshToken, getCurrentVIASUser]);

  // handle refreshing of token

  useEffect(() => {
    if (tokenExpiration !== null) {
      const timeoutId = setTimeout(async () => {
        try {
          await refreshToken();
          const { tokenExpiration } = await getCurrentVIASUser();
          setTokenExpiration(tokenExpiration);
        } catch (e) {
          setIsAuthed(false);
        }
      }, getTimeToExpire(tokenExpiration));

      return () => clearTimeout(timeoutId);
    }
  }, [tokenExpiration]);

  const auth = useMemo(() => ({ login, logout, isLoading, isAuthed }), [isLoading, isAuthed, login, logout]);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
